<template>
    <aside class="sidebar">
        <!-- Logo -->
        <router-link to="/" class="logo">
            <img src="@/assets/tool-logo.png" alt="ツールロゴ" />
        </router-link>

        <!-- Navigation -->
        <nav class="nav">
            <ul class="nav-list">
                <li v-for="content in sidecontents" :key="content.index">
                    <router-link :to="content.to" class="nav-item">
                        {{ content.title }}
                    </router-link>
                </li>
            </ul>

            <div class="divider"></div>

            <ul class="nav-list">
                <li v-for="content in sideAnotherContents" :key="content.index">
                    <a :href="content.to" target="_blank" class="nav-item external">
                        {{ content.title }}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </a>
                </li>
                <li>
                    <router-link to="/rule" class="nav-item">
                        ご利用のルール
                    </router-link>
                </li>
                <li>
                    <router-link to="/news" class="nav-item">
                        アプデ情報
                    </router-link>
                </li>
            </ul>
        </nav>

        <!-- Banner Links -->
        <div class="banners">
            <a href="https://hari-stream.com/" target="_blank" rel="noopener noreferrer" class="banner-link">
                <img src="@/assets/mini-hari.png" alt="hari-stream" />
            </a>
            <a href="https://talk-boost.com/" target="_blank" rel="noopener noreferrer" class="banner-link">
                <img src="@/assets/mini-talkboost.png" alt="talk-boost" />
            </a>
        </div>

        <!-- Footer -->
        <footer class="footer">
            <p>&copy; ruri.info</p>
        </footer>
    </aside>
</template>
<script>
export default {
  name: "app",
  data() {
    return{
        sidecontents: [
            {
                index: 1,
                type: "internal",
                to: "/clockcreate",
                title: "デジタル時計",
            },
            {
                index: 2,
                type: "internal",
                to: "/ytcomment",
                title: "コメント欄用CSS",
            },
            {
                index: 3,
                type: "internal",
                to: "/discordroom",
                title: "DiscordオーバレイCSS",
            },
            {
                index: 4,
                type: "internal",
                to: "/timer",
                title: "タイマー",
            },
            {
                index: 5,
                type: "internal",
                to: "/multicounter",
                title: "カウンター",
            },
            {
                index: 6,
                type: "internal",
                to: "/roulette",
                title: "ルーレット",
            },
            {
                index: 7,
                type: "internal",
                to: "/bgcreate",
                title: "背景生成ツール",
            },
        ],
        sideAnotherContents: [
            {
                index: 2,
                type: "external",
                to: "https://www.ruri.info/",
                title: "ruri.info",
            },
        ],
    }
  }
}
</script>
<style scoped>
/* Reset */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Sidebar Container */
.sidebar {
    display: none;
    width: 280px;
    height: 100vh;
    position: sticky;
    top: 0;
    background: white;
    border-right: 1px solid #e2e8f0;
    overflow-y: auto;
    padding: 24px 0;
    flex-direction: column;
}

/* Logo */
.logo {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

.logo img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: opacity 0.15s ease;
}

.logo:hover img {
    opacity: 1;
}

/* Navigation */
.nav {
    flex: 1;
    padding: 0 16px;
}

.nav-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.nav-list li {
    margin: 0;
}

.nav-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    margin: 2px 0;
    color: #64748b;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    border-radius: 6px;
    transition: all 0.15s ease;
}

.nav-item:hover {
    background-color: #f8fafc;
    color: #334155;
}

.nav-item.external svg {
    width: 14px;
    height: 14px;
    opacity: 0.6;
    transition: opacity 0.15s ease;
}

.nav-item.external:hover svg {
    opacity: 1;
}

/* Active States */
.nav-item.router-link-active {
    background-color: #0f172a;
    color: white;
}

.nav-item.router-link-active:hover {
    background-color: #1e293b;
}

.nav-item.router-link-exact-active {
    background-color: #0f172a;
    color: white;
}

.nav-item.router-link-exact-active:hover {
    background-color: #1e293b;
}

/* Divider */
.divider {
    height: 1px;
    background-color: #e2e8f0;
    margin: 24px 8px;
}

/* Banners */
.banners {
    padding: 24px 24px 0 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.banner-link {
    display: block;
    border-radius: 8px;
    overflow: hidden;
    transition: opacity 0.15s ease;
}

.banner-link:hover {
    opacity: 0.9;
}

.banner-link img {
    width: 100%;
    height: auto;
    display: block;
}

/* Footer */
.footer {
    margin-top: auto;
    padding: 24px;
    text-align: center;
}

.footer p {
    color: #94a3b8;
    font-size: 12px;
    font-weight: 500;
}

/* Media Query */
@media (min-width: 768px) {
    .sidebar {
        display: flex;
    }
}

/* Scrollbar */
.sidebar::-webkit-scrollbar {
    width: 6px;
}

.sidebar::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}
</style>